import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
} from "@mui/material";

export const ReplaceConversationDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Replace current conversation?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You already have an assistant conversation open. Opening a new one
          will replace the current conversation. Any unsaved context will be
          lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Replace
        </Button>
      </DialogActions>
    </Dialog>
  );
};
